import { useState, useEffect, useMemo } from "react";
import { modalCargando, mensajeEstatico } from "../../../components/ui/sweetAlerts";
import { createFetchTableData } from "../../../utils/createFetchTableData";
import { post } from "../../../api/apis";

export const useMonitor = (proveedor) => {
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);


  const initialSortBy = "IdLote";
  const initialSortDir = "desc";



  const fetchTableData = useMemo(
    () =>
      createFetchTableData({
        url: "monitor/contratos",
        initialSortBy, // columna por defecto
        initialSortDir, // dirección por defecto
        extraParams: { proveedor: proveedor }, // Parámetro adicional para el backend
        dataPath: ["data", "data", "data"], // ruta dentro de la respuesta donde se encuentran los datos
        totalPath: ["data", "data", "total"], // ruta dentro de la respuesta donde se encuentra el total
      }),
    [initialSortBy, initialSortDir],
  );
  



  // Manejar doble clic en una fila para abrir el modal
  const handleRowDoubleClick = rowData => {
    setSelectedRow(rowData);
    setShowModal(true);
  };

  const handleKeyDown = e => {
    if (e.key === "Escape") {
      setShowModal(false);
    }
  };

  const handleClickOutside = e => {
    // Si el modal está abierto y el clic no es dentro del contenido del modal
    const modalContent = document.querySelector(".modal-content");
    if (modalContent && !modalContent.contains(e.target)) {
      setShowModal(false);
    }
  };

  const reenviarContrato = async id => {
    try {
      modalCargando("Reenviando");
      const resp = await post("reenvio_contrato", { id_contrato: id });
      if (resp.data.status === "info") {
        mensajeEstatico("info", "Atención", resp.data.message);
      } else if (resp.data.status === "success") {
        mensajeEstatico("success", "Éxito", resp.data.message);
        // Aquí podrías refrescar la tabla si lo necesitas
      } else {
        mensajeEstatico("error", "Error", "Ha ocurrido un error.");
      }
    } catch (error) {
      console.error("Error al reenviar contrato:", error);
      mensajeEstatico("error", `No se pudo reenviar el contrato ${id}.`);
    }
  };

  // Cerrar modal al presionar Escape o clic fuera del modal
  useEffect(() => {
    if (!showModal) return;

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal]);

  return {
    handleKeyDown, handleClickOutside, handleRowDoubleClick, showModal, selectedRow, setShowModal, reenviarContrato, fetchTableData
  }
}